import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LabeledSelect = styled.div({
	marginTop: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SelectLabel = styled.label({
	display: 'inline-block',
	marginRight: token('space.200'),
	padding: `${token('space.050')} ${token('space.0')} ${token('space.0')} ${token('space.0')}`,
	textAlign: 'right',
	width: '130px',
	wordWrap: 'break-word',
});

/* Note that we can't use compiled on any components derived from react-select; for
these we need to pass styling objects via the `styles` prop */
export const selectStyles = (fullWidth?: boolean) => ({
	display: 'inline-block',
	width: fullWidth ? '100%' : '300px',
});

export const customSelectStyles = (fullWidth?: boolean) => ({
	container: (provided) => ({
		...provided,
		...selectStyles(fullWidth),
	}),
});
